import { Container, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledFormContainer = styled(Container)(({ theme }) => ({
    padding: theme.spacing(2, 3, 2),
    height: 'calc(100vh - 160px)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '& .MuiTextField-root': {
        marginBottom: theme.spacing(2),
    },
    '& .form-content': {
        display: 'flex',
        flex: 1,
        gap: theme.spacing(2),
        overflow: 'hidden', // Prevent content overflow
    },
    '& .form-section': {
        flex: 2,
        overflowY: 'auto', // Enable scrolling for form section
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        '& form': {
            flex: 1,
            overflowY: 'auto', // Enable scrolling for form
        },
    },
    '& .map-section': {
        flex: 1,
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        '& iframe': {
            flex: 1,
            border: 'none',
            borderRadius: theme.shape.borderRadius,
        },
    },
    '& .address-autocomplete': {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    '& .wizard-section': {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    '& .wizard-list': {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
    },
    '& .wizard-footer': {
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(2),
        paddingTop: theme.spacing(2),
        marginTop: theme.spacing(1),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    '& .wizard-section .MuiTextField-root': {
        marginBottom: 0,
    },
    '& .wizard-table-wrap': {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
    },
    '& .wizard-table-wrap .wizard-list': {
        borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
    },
}))

export const SectionTitle = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
}))
